import { useEffect, useState } from 'react';
import { api } from '../../shared/api';
import { scheduleAccountRead } from './readRequest';

/** Retain the displayed result while refreshing, but expose ready only for the
 * current query. Cancel superseded reads instead of letting them overwrite it. */
export function useAccountRead<T>(path: string | null, refresh = 0, delay = 0) {
  const key = JSON.stringify([path, refresh]);
  const [state, setState] = useState<{ key?: string; data?: T; pending: boolean; error?: unknown }>({ pending: false });

  useEffect(() => {
    if (!path) { setState(previous => ({ ...previous, key, pending: false, error: undefined })); return; }
    setState(previous => ({ ...previous, key, pending: true, error: undefined }));
    return scheduleAccountRead(signal => api<T>(path, { signal }), delay,
      data => setState({ key, data, pending: false }),
      error => setState(previous => ({ ...previous, key, pending: false, error })));
  }, [path, key, delay]);

  const loading = !!path && (state.key !== key || state.pending);
  const error = state.key === key ? state.error : undefined;
  return { data: path ? state.data : undefined, loading, error, ready: !!path && state.key === key && !state.pending && !error };
}
